import { render, staticRenderFns } from "./dianchifuwu.vue?vue&type=template&id=9eb0d64a&scoped=true&"
import script from "./dianchifuwu.vue?vue&type=script&lang=js&"
export * from "./dianchifuwu.vue?vue&type=script&lang=js&"
import style0 from "./dianchifuwu.vue?vue&type=style&index=0&id=9eb0d64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb0d64a",
  null
  
)

export default component.exports